<template>
    <sink-handler>
        <div class="not-found-container">
            <div class="flex-container">
                <!-- <img
                    src="static/img/flat-tire.svg"
                    alt="Pneu crevé"
                    class="image"
                > -->
                <div class="description">
                    <p class="not-found">404</p>
                    <p class="text">Page non trouvée, veuillez contactez un administrateur.</p>
                </div>
            </div>
        </div>
    </sink-handler>
</template>

<script>
import sinkHandler from 'fundation-app-vuejs/src/components/pages/sinkHandler';
export default {
    components: {
        sinkHandler
    },
};
</script>

<style lang="scss">
.not-found-container {
    margin-top: 66px;
    width: 90%;
    height: 100vh;

    .flex-container {

        display: flex;
        align-items: center;
        justify-content: center;

        .image {
            width: 30%;
            margin: 30px 50px;
        }

        .description {
            display: flex;
            flex-direction: column;
            align-items: center;

            .not-found {
                font-size: percentage(8);
            }

            .text {
                font-size: larger;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/page/NotFound/Index.vue